import React, { useState } from 'react';
import { TouchableOpacity, StyleSheet, Text, View } from 'react-native';
import cloneWithProps from '../../../shared/utils/dom/cloneWithProps';
const IntentSelect = _ref => {
  let {
    options,
    selected,
    placeholder = 'Choose here',
    endSelectComponent,
    menuTitle,
    menuDescription,
    externalStyles,
    customRight,
    onSelect
  } = _ref;
  const {
    containerStyle,
    innerContainerStyle,
    buttonStyle,
    buttonTextStyle,
    buttonStartIconStyle,
    endSelectComponentStyle,
    menuStyle,
    menuItemIconStyle,
    menuItemIconActiveStyle,
    menuItemStyle,
    menuTitleStyle,
    menuDescriptionStyle,
    menuItemTextStyle,
    menuItemTextActiveStyle
  } = externalStyles || {};
  const [open, setOpen] = useState(false);
  const handleOpenSelect = () => {
    setOpen(true);
  };
  const handleCloseSelect = () => {
    setOpen(false);
  };
  const handleSelectItem = item => {
    onSelect(item);
    handleCloseSelect();
  };
  const renderMenuItem = item => {
    const isSelected = item.value === selected?.value;
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      key: item.label,
      style: [styles.menuItem, menuItemStyle],
      onPress: () => handleSelectItem(item)
    }, !!item.icon && cloneWithProps(item.icon, {
      ...(menuItemIconStyle || {}),
      ...(isSelected ? menuItemIconActiveStyle : {})
    }), /*#__PURE__*/React.createElement(Text, {
      style: [styles.menuItemText, menuItemTextStyle, isSelected ? menuItemTextActiveStyle : {}]
    }, item.label));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, containerStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.innerContainer, innerContainerStyle]
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: open ? handleCloseSelect : handleOpenSelect,
    style: [styles.button, buttonStyle]
  }, !!selected?.icon && cloneWithProps(selected?.icon, buttonStartIconStyle), /*#__PURE__*/React.createElement(Text, {
    style: [styles.buttonText, buttonTextStyle],
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, selected?.label || placeholder), !!endSelectComponent && cloneWithProps(endSelectComponent, endSelectComponentStyle)), customRight), open && /*#__PURE__*/React.createElement(View, {
    style: [styles.menu, menuStyle]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.menuTitle, menuTitleStyle]
  }, menuTitle), /*#__PURE__*/React.createElement(Text, {
    style: [styles.menuDescription, menuDescriptionStyle]
  }, menuDescription), options.map(renderMenuItem)));
};
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    marginHorizontal: 20,
    zIndex: 1,
    justifyContent: 'center'
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '600',
    marginLeft: 5,
    flex: 1,
    display: 'flex'
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 50,
    left: 0,
    backgroundColor: 'white',
    borderWidth: 2,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 24
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginVertical: 5
  },
  menuTitle: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 32,
    marginBottom: 5
  },
  menuDescription: {
    fontSize: 16,
    marginBottom: 16,
    lineHeight: 24
  },
  menuItemText: {
    fontSize: 16,
    fontWeight: '600',
    marginLeft: 5
  }
});
export default IntentSelect;
//# sourceMappingURL=IntentSelect.js.map